import { Configuration } from "@azure/msal-browser";

const redirectUri = import.meta.env.VITE_REDIRECT_URI.replace(/\/+$/, "");

export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_CLIENT_ID,
        authority: import.meta.env.VITE_AUTHORITY,
        redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        allowRedirectInIframe: false,
    },
};

export const loginRequest = {
    scopes: [import.meta.env.VITE_SCOPES],
};

/** Used by acquireTokenSilent hidden iframes — must be a blank bridge page, not the main app. */
export const silentRedirectUri = `${redirectUri}/auth-redirect.html`;